import { useEffect, useState } from "react";
import { TrendingUp, TrendingDown, Minus, Sparkles, Info } from "lucide-react";
import api from "@/lib/api";
import AIContentBlock from "@/components/AIContentBlock";

const Movement = ({ m }) => {
  if (m === "up") return <TrendingUp className="w-4 h-4 text-emerald-500" />;
  if (m === "down") return <TrendingDown className="w-4 h-4 text-rose-500" />;
  if (m === "new") return <Sparkles className="w-4 h-4 text-amber-500" />;
  return <Minus className="w-4 h-4 text-slate-300" />;
};

export default function Charts() {
  const [charts, setCharts] = useState([]);

  useEffect(() => {
    api.get("/charts").then((r) => setCharts(r.data)).catch(console.error);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="charts-page">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-slate-500 mb-3">Charts &amp; Editorial Lists</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-slate-900">Curated, Not <span className="gradient-text">Just Counted.</span></h1>
      <p className="mt-3 text-slate-600 max-w-2xl">Every list publishes its territory, period and methodology. Editorial selections are never presented as popularity rankings.</p>

      <AIContentBlock pageKey="charts" topic="Music charts and transparent editorial lists" imgQuery="vinyl records collection music shop" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-10">
        {charts.map((ch) => (
          <div key={ch.id} className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden" data-testid={`chart-card-${ch.slug}`}>
            <div className="p-6 bg-gradient-to-r from-rose-50 via-pink-50 to-purple-50 border-b border-slate-100">
              <h2 className="font-display text-xl font-black text-slate-900">{ch.name}</h2>
              <p className="text-xs text-slate-500 mt-1">{ch.publisher} · {ch.territory} · {ch.period}</p>
              <p className="text-[11px] text-slate-500 mt-3 flex gap-1.5 leading-relaxed"><Info className="w-3.5 h-3.5 text-purple-500 shrink-0 mt-0.5" /> {ch.methodology}</p>
            </div>
            <div className="px-4">
              <AIContentBlock pageKey={`chart-${ch.slug}`} topic={`${ch.name} — a ${ch.territory} music chart by ${ch.publisher}`} compact />
            </div>
            <ol className="divide-y divide-slate-50">
              {ch.entries?.map((e) => (
                <li key={e.rank} className="flex items-center gap-4 px-6 py-3 hover:bg-slate-50 transition-colors" data-testid={`chart-entry-${ch.slug}-${e.rank}`}>
                  <span className="font-display font-black text-lg w-6 text-center gradient-text">{e.rank}</span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-bold text-slate-900 truncate">{e.title}</p>
                    <p className="text-xs text-slate-500 truncate">{e.artist}</p>
                  </div>
                  <Movement m={e.movement} />
                </li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </div>
  );
}
